export var OnboardingQuestionType;
(function (OnboardingQuestionType) {
    OnboardingQuestionType["TileSingleSelect"] = "TileSingleSelect";
    OnboardingQuestionType["TileMultiSelect"] = "TileMultiSelect";
    OnboardingQuestionType["DropdownSelect"] = "DropdownSelect";
    OnboardingQuestionType["TextInput"] = "TextInput";
    OnboardingQuestionType["Checkbox"] = "Checkbox";
})(OnboardingQuestionType || (OnboardingQuestionType = {}));
